import React from 'react';
import GallectionDeviationManager from '../../Deviations/DeviationManager/GallectionDeviationManager';
import GallectionSidebar from './GallectionSidebar';
export class GallectionContentManager extends React.Component {
    render() {
        return /*#__PURE__*/ React.createElement(GallectionDeviationManager, {
            sideBarContent: /*#__PURE__*/ React.createElement(GallectionSidebar, null)
        });
    }
}
export default GallectionContentManager;

//# sourceMappingURL=GallectionContentManager.js.map